import { Component, OnInit, Input, EventEmitter, ChangeDetectorRef, ViewRef, ChangeDetectionStrategy } from '@angular/core';
import { Options } from "@angular-slider/ngx-slider";
import { FieldType } from "@ngx-formly/core";
import { restore } from "./../../../../assets/json/restoreTooltip.en";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';

import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { InputErrorsStateService } from "../../../core-module/services/state/input-errors-state.service";
@Component({
  standalone: false,
  selector: "app-touch-dim",
  templateUrl: "./touch-dim.component.html",
  styleUrls: ["./touch-dim.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TouchDimComponent extends FieldType implements OnInit {
  @Input() field;
  valOptions: Options = {};
  floorValue;
  ceilValue;
  defaultValue;
  enableFeatureTouchDimCheckbox: LegacyAny = false;
  isResetDisabled;
  private isLoadingData = false;
  isSliderClick;
  manualRefresh: EventEmitter<void> = new EventEmitter<void>();
  sliderValue;
  textboxValue;
  defaultColor = true;
  deviceName;
  isHidden;
  isAocEnabled;
  isEnableTouchDimFeature;
  inputError = false;
  quickConfigvalue: boolean;
  quickConfigCustomCSS;
  setQuickConfig;
  restoreText = restore;
  booleanValue = true;
  isToggleLimitEnabled;
  isLastKnownEnabled: LegacyAny = true;
  sliderDisabled;
  fileResponse: LegacyAny;
  isEdited: LegacyAny;
  ngModelval: LegacyAny = [];
  calculatedPercentageVal = null;
  touchDimObj = {};
  isTwEnabled = false;
  cctTextboxValue;
  cctSliderValue;
  cctInputError = false;
  cctFloorValue;
  cctCeilValue;
  cctDefaultValue;
  cctSliderDisabled = true;
  cctValOptions: Options = {};
  unsubscribe = new Subject<void>();
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private inputErrors: InputErrorsStateService,
    private aloAoc: AloAocStateService,
    private featureDefaults: FeatureDefaultsStateService
  ) {
    super();
  }
  ngOnInit() {
    this.isEdited = false;
    this.inputErrors.getTouchDimDefaultData.subscribe((response) => {
      if (response) {
        this.defaultColor = true;
        this.resetDefaultTouchDim();
      }
    });

    // Guard: If schema not loaded, initialize with safe defaults and return
    if (!this.field || !this.field.properties || (!this.field.oneOf && !this.field.properties?.PowerOnLevel?.oneOf)) {
      this.valOptions = { floor: 0, ceil: 254 };
      return;
    }

    // Subscribe to state changes to reload when read device updates data
    this.appState.getState()
      .pipe(
        distinctUntilChanged((prev, curr) => {
          // Only emit when TouchDim data actually changes
          const prevTouchDim = prev?.configurationData?.resp?.TouchDim;
          const currTouchDim = curr?.configurationData?.resp?.TouchDim;
          return JSON.stringify(prevTouchDim) === JSON.stringify(currTouchDim);
        }),
        takeUntil(this.unsubscribe)
      )
      .subscribe((state) => {
        if (state.configurationData?.resp?.TouchDim) {
          const touchDimData = state.configurationData.resp.TouchDim;
          // Only reload if values differ from current state
          if (touchDimData.PowerOnLevel !== undefined &&
              (touchDimData.PowerOnLevel !== this.textboxValue ||
               touchDimData.TouchDimEnabled !== this.isEnableTouchDimFeature ||
               touchDimData.IgnoreToggleLimits !== this.isToggleLimitEnabled ||
               (this.hasTouchDimTwEnabled() && touchDimData.TouchDimTwEnabled !== this.isTwEnabled) ||
               (this.hasPowerOnCCT() && touchDimData.PowerOnCCT !== this.ngModelval["PowerOnCCT"]))) {
            this.addTouchDimLoadedFeatureReadValues(touchDimData);
          }
        }
      });

    this.isEnableTouchDimFeature =
      this.field.properties.TouchDimEnabled.default;
    if (this.isEnableTouchDimFeature || !this.isEnableTouchDimFeature) {
      this.enableFeatureTouchDimCheckbox = true;
    }
    this.isToggleLimitEnabled =
      this.field.properties.IgnoreToggleLimits.default;
    this.floorValue = this.getPowerOnLevelMin();
    this.ceilValue = this.getPowerOnLevelMax();
    this.defaultValue = this.getPowerOnLevelConst();
    if (this.defaultValue === 255) {
      this.defaultValue = this.defaultValue - 1;
    }
    if (this.isLastKnownEnabled) {
      this.sliderDisabled = true;
    } else {
      this.sliderDisabled = false;
    }
    this.valOptions = {
      floor: this.floorValue,
      ceil: this.ceilValue,
      disabled: false,
    };
    this.textboxValue = this.isLastKnownEnabled
      ? this.defaultValue
      : this.sliderValue;
    this.sliderValue = this.textboxValue;
    if (this.textboxValue >= this.floorValue && !this.inputError) {
      const y = (this.textboxValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
    this.ngModelval["IgnoreToggleLimits"] = this.isToggleLimitEnabled;
    this.ngModelval["PowerOnLevel"] = this.textboxValue;
    this.ngModelval["TouchDimEnabled"] = this.isEnableTouchDimFeature;
    this.ngModelval["LastKnownEnabled"] = this.isLastKnownEnabled;
    if (this.hasTouchDimTwEnabled()) {
      this.isTwEnabled = this.field.properties.TouchDimTwEnabled.default;
      this.ngModelval["TouchDimTwEnabled"] = this.isTwEnabled;
    }
    if (this.hasPowerOnCCT()) {
      this.cctFloorValue = this.getPowerOnCCTMin();
      this.cctCeilValue = this.getPowerOnCCTMax();
      this.cctDefaultValue = this.getPowerOnCCTMax();
      this.cctTextboxValue = this.cctSliderValue = this.cctDefaultValue;
      this.cctSliderDisabled = this.isLastKnownEnabled || !this.isTwEnabled;
      this.cctValOptions = { floor: this.cctFloorValue, ceil: this.cctCeilValue, disabled: false };
      this.ngModelval["PowerOnCCT"] = this.getPowerOnCCTConst();
    }
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox";
        this.setQuickConfig = "quickConfig";
      } else if (data === "standard") {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });

    // Note: Skip calling lastKnownEnabled, enableFeature, toggleLimitEnabled, valueChanged, sliderValueChange
    // during initialization. These will be called from addTouchDimLoadedFeatureReadValues after loading SaveSetData.
    // Calling them here with default values would overwrite saved values.

    if (this.isEnableTouchDimFeature === true) {
      this.isResetDisabled = false;
    } else {
      this.isResetDisabled = true;
      this.sliderDisabled = true;
      if (this.hasPowerOnCCT()) {
        this.cctSliderDisabled = true;
      }
    }
    this.inputErrors.sendTouchDimInputError(this.inputError);
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);

    // CENTRALIZED FEATURE DATA LOADING
    // Check unSelectedFeat first (for configure flow)
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (element["featureName"].toString().toUpperCase() === "TOUCHDIM") {
          isConfigEdited = true;
          const touchDimRead: LegacyAny = element["featureParameters"][0];
          this.addTouchDimLoadedFeatureReadValues(touchDimRead);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    // If not in configure flow, use centralized method to load feature data
    // This automatically checks SaveSetData first, then ConfigurationData
    if (isConfigEdited === false) {
      const touchDimData = this.appState.getFeatureData('TouchDim');
      if (touchDimData && Object.keys(touchDimData).length > 0) {
        this.addTouchDimLoadedFeatureReadValues(touchDimData);
      }
    }

    this.sendTouchDimData();
    this.isEdited = true;
  }
  addTouchDimLoadedFeatureReadValues(TouchDim: LegacyAny) {
    this.isLoadingData = true;
    let lastKnownEnabledCheck = false;
    const touchDimObj = TouchDim;
    const keys = Object.keys(touchDimObj);
    const values = Object.values(touchDimObj);
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval = result;
    let powerOnLeveVal = result["PowerOnLevel"];
    this.ngModelval["IgnoreToggleLimits"] = result["IgnoreToggleLimits"];
    this.isToggleLimitEnabled = result["IgnoreToggleLimits"];
    if (
      result["PowerOnLevel"] === this.getPowerOnLevelConst() ||
      (result["PowerOnLevel"] === this.getPowerOnLevelMax() &&
        result["LastKnownEnabled"] === true)
    ) {
      lastKnownEnabledCheck = true;
      powerOnLeveVal = this.getPowerOnLevelMax();
    }
    const loadedFF = this.appState.getLoadffflow();
    const readingDevice = this.appState.getReadingDevice();
    const isWriting = this.appState.getIsWriting();
    if (
      loadedFF === true ||
      readingDevice === true ||
      isWriting === true
    ) {
      this.ngModelval["LastKnownEnabled"] = lastKnownEnabledCheck;
      this.isLastKnownEnabled = lastKnownEnabledCheck;
    } else if (
      result["PowerOnLevel"] === this.getPowerOnLevelConst() ||
      (result["PowerOnLevel"] === this.getPowerOnLevelMax() &&
        result["LastKnownEnabled"] === true)
    ) {
      this.ngModelval["LastKnownEnabled"] = this.isLastKnownEnabled = true;
    } else {
      this.ngModelval["LastKnownEnabled"] = this.isLastKnownEnabled =
        result["LastKnownEnabled"];
    }
    if (this.hasTouchDimTwEnabled()) {
      this.isTwEnabled = result["TouchDimTwEnabled"] ?? false;
      this.ngModelval["TouchDimTwEnabled"] = this.isTwEnabled;
    }
    // Save original device CCT value BEFORE lastKnownEnabled runs, because
    // lastKnownEnabled writes to ngModelval["PowerOnCCT"] and since
    // ngModelval === result (same reference), it corrupts result["PowerOnCCT"].
    const originalDeviceCCT = this.hasPowerOnCCT() ? result["PowerOnCCT"] : undefined;
    this.lastKnownEnabled(this.isLastKnownEnabled);
    if (this.hasPowerOnCCT()) {
      const cctVal = originalDeviceCCT;
      this.cctSliderDisabled = this.isLastKnownEnabled || !this.isTwEnabled;
      if (this.isLastKnownEnabled) {
        if (cctVal !== undefined && cctVal !== null && cctVal !== this.getPowerOnCCTConst()) {
          // SaveSet path: restore the user-entered value
          this.cctTextboxValue = this.cctSliderValue = cctVal;
          this.ngModelval["PowerOnCCT"] = cctVal;
        } else {
          // Device path: sentinel from device → show default
          this.cctTextboxValue = this.cctSliderValue = this.cctDefaultValue;
          this.ngModelval["PowerOnCCT"] = this.getPowerOnCCTConst();
        }
      } else if (cctVal !== undefined && cctVal !== null && cctVal !== this.getPowerOnCCTConst()) {
        this.cctTextboxValue = this.cctSliderValue = cctVal;
        this.ngModelval["PowerOnCCT"] = cctVal;
      } else {
        this.cctTextboxValue = this.cctSliderValue = this.cctDefaultValue;
        this.ngModelval["PowerOnCCT"] = this.cctDefaultValue;
      }
      // mirror valueChanged: evaluate error so it shows on refresh
      this.cctInputError = !this.isLastKnownEnabled &&
        (isNaN(this.cctTextboxValue) || this.cctTextboxValue < this.cctFloorValue || this.cctTextboxValue > this.cctCeilValue);
    }
    if (powerOnLeveVal === undefined || powerOnLeveVal === null) {
        powerOnLeveVal = this.defaultValue;
    }
    this.ngModelval["PowerOnLevel"] = powerOnLeveVal;
    this.textboxValue = powerOnLeveVal;
    this.ngModelval["TouchDimEnabled"] = result["TouchDimEnabled"];
    this.isEnableTouchDimFeature = result["TouchDimEnabled"];
    const touchDimEnabled = result["TouchDimEnabled"];
    this.toggleLimitEnabled(this.isToggleLimitEnabled);
    this.valueChanged(powerOnLeveVal);
    this.sliderValueChange(powerOnLeveVal);
    this.enableFeature(touchDimEnabled);
    this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.isLoadingData = false;
    this.ref.markForCheck();
  }

  sliderEvent(val) {
    this.defaultColor = false;
    this.inputError = false;

    // Auto-enable feature when user interacts with slider
    if (!this.isEnableTouchDimFeature && this.isEdited && !this.isLoadingData) {
      this.isEnableTouchDimFeature = true;
      this.ngModelval["TouchDimEnabled"] = true;
      this.isResetDisabled = false;
    }

    if (
      isNaN(val) ||
      val.length <= 0 ||
      val < this.floorValue ||
      val > this.ceilValue
    ) {
      this.inputError = true;
      this.textboxValue = val;
      this.sliderValue = Number(this.textboxValue);
      this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
    } else {
      this.inputError = false;
      this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
      this.textboxValue = val;
      this.sliderValue = this.textboxValue;
    }
    if (this.textboxValue >= this.floorValue && !this.inputError) {
      const y = (this.textboxValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
    this.ngModelval["PowerOnLevel"] = this.textboxValue;
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.sendTouchDimData();
  }

  valueChanged(value) {
    this.defaultColor = false;
    this.inputError = false;

    // Auto-enable feature when user interacts with textbox
    if (!this.isEnableTouchDimFeature && this.isEdited && !this.isLoadingData) {
      this.isEnableTouchDimFeature = true;
      this.ngModelval["TouchDimEnabled"] = true;
      this.isResetDisabled = false;
    }

    if (
      isNaN(value) ||
      value.length <= 0 ||
      value < this.floorValue ||
      value > this.ceilValue
    ) {
      this.inputError = true;
      this.textboxValue = value;
      if (value.length <= 0) {
        this.sliderValue = Number(0);
      }
      this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
    } else {
      this.inputError = false;
      this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
      this.textboxValue = value;
      this.sliderValue = this.textboxValue;
    }
    if (this.textboxValue >= this.floorValue && !this.inputError) {
      const y = (this.textboxValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
    this.ngModelval["PowerOnLevel"] = this.textboxValue;
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.sendTouchDimData();
  }
  sliderValueChange(value) {
    this.sliderEvent(value);
  }
  resetDefaultTouchDim() {
    this.isEnableTouchDimFeature =
      this.field.properties.TouchDimEnabled.default;
    if (this.isEnableTouchDimFeature) {
      this.enableFeatureTouchDimCheckbox = true;
    }
    this.isLastKnownEnabled = true;
    if (this.isLastKnownEnabled) {
      this.sliderDisabled = true;
    } else {
      this.sliderDisabled = false;
    }
    this.isToggleLimitEnabled =
      this.field.properties.IgnoreToggleLimits.default;
    this.floorValue = this.getPowerOnLevelMin();
    this.ceilValue = this.getPowerOnLevelMax();
    this.defaultValue = this.getPowerOnLevelConst();
    if (this.defaultValue === 255) {
      this.defaultValue = this.defaultValue - 1;
    }
    this.valOptions = {
      floor: this.floorValue,
      ceil: this.ceilValue,
      disabled: false,
    };
    this.textboxValue = this.sliderValue = this.defaultValue;
    this.inputError = false;
    if (this.textboxValue >= this.floorValue) {
      const y = (this.textboxValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
    if (this.isLastKnownEnabled)
      this.ngModelval["PowerOnLevel"] =
        this.field.properties.PowerOnLevel.default - 1;
    this.ngModelval["IgnoreToggleLimits"] = this.isToggleLimitEnabled;
    this.ngModelval["TouchDimEnabled"] = this.isEnableTouchDimFeature;
    this.ngModelval["LastKnownEnabled"] = this.isLastKnownEnabled;
    if (this.hasTouchDimTwEnabled()) {
      this.isTwEnabled = this.field.properties.TouchDimTwEnabled.default;
      this.ngModelval["TouchDimTwEnabled"] = this.isTwEnabled;
    }
    if (this.hasPowerOnCCT()) {
      this.cctTextboxValue = this.cctSliderValue = this.cctDefaultValue;
      this.cctSliderDisabled = true;
      this.cctInputError = false;
      this.ngModelval["PowerOnCCT"] = this.getPowerOnCCTConst();
    }
    // delegate to enableFeature so sliderDisabled/isResetDisabled reflect the restored default
    this.enableFeature(this.isEnableTouchDimFeature);
    this.isSliderClick = false;
    this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
    this.inputErrors.setTouchDimEditedData(this.ngModelval);
    this.sendTouchDimData();
    this.ref.markForCheck();
  }
  setConfigurationData(value, keyVal) {
    // CENTRALIZED FEATURE DATA SAVING
    // This automatically saves to both ConfigurationData and SaveSetData
    this.appState.setFeatureData(keyVal, value);
  }
  enableFeature(event) {
    this.isEnableTouchDimFeature = event;
    if (event) {
      this.sliderDisabled = this.isLastKnownEnabled;
    } else {
      this.sliderDisabled = true;
      if (this.hasPowerOnCCT()) {
        this.cctSliderDisabled = true;
      }
    }
    if (event) {
      this.isResetDisabled = false;
    } else {
      this.isResetDisabled = true;
    }
    this.ngModelval["TouchDimEnabled"] = event;
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.sendTouchDimData();
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  lastKnownEnabled(event) {
    this.defaultColor = true;
    const powerLevelOneMin = this.getPowerOnLevelMin();
    const powerLevelOneMax = this.getPowerOnLevelMax();
    const props = this.field.properties;
    const powerLevelPropDefault = props.PowerOnLevel.default;
    this.isLastKnownEnabled = event;
    if (this.isLastKnownEnabled) {
      this.sliderDisabled = true;
    } else {
      this.sliderDisabled = false;
    }
    if (this.isLastKnownEnabled) {
      if (this.ngModelval["PowerOnLevel"] !== powerLevelPropDefault - 1) {
        this.defaultColor = false;
      }
    }
    if (!this.isLastKnownEnabled) {
      if (
        this.ngModelval["PowerOnLevel"] >= powerLevelOneMin &&
        this.ngModelval["PowerOnLevel"] <= powerLevelOneMax
      ) {
        this.defaultColor = false;
      }
    }
    this.ngModelval["LastKnownEnabled"] = event;
    if (this.hasPowerOnCCT()) {
      if (event) {
        this.cctSliderDisabled = true;
        if (this.cctInputError) {
          this.cctTextboxValue = this.cctSliderValue = this.cctDefaultValue;
          this.cctInputError = false;
        }
        // Store the displayed CCT value (not the sentinel); the write layer substitutes the sentinel
        this.ngModelval["PowerOnCCT"] = this.cctTextboxValue;
      } else {
        this.cctSliderDisabled = !this.isTwEnabled;
        // restore the value that was showing before last-known was checked
        this.cctSliderValue = this.cctTextboxValue;
        this.ngModelval["PowerOnCCT"] = this.cctTextboxValue;
      }
    }
    if (event && this.inputError) {
      this.textboxValue = this.sliderValue = this.getPowerOnLevelMax();
      this.ngModelval["PowerOnLevel"] = this.textboxValue;
      this.inputError = false;
    }
    this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.sendTouchDimData();
  }
  checkDefault() {
    const powerLevelOneMin = this.getPowerOnLevelMin();
    const powerLevelOneMax = this.getPowerOnLevelMax();
    const props = this.field.properties;

    const powerLevelPropDefault = props.PowerOnLevel.default;
    const ignoreLimitPropDefault = props.IgnoreToggleLimits.default;
    const touchEnabledPropDefault = props.TouchDimEnabled.default;

    this.defaultColor = true;
    if (this.isToggleLimitEnabled !== ignoreLimitPropDefault) {
      this.defaultColor = false;
    }
    if (this.isEnableTouchDimFeature !== touchEnabledPropDefault) {
      this.defaultColor = false;
    }
    if (this.isLastKnownEnabled) {
      if (this.textboxValue !== powerLevelPropDefault - 1) {
        this.defaultColor = false;
      }
    }
    if (!this.isLastKnownEnabled) {
      if (
        this.textboxValue >= powerLevelOneMin &&
        this.textboxValue <= powerLevelOneMax
      ) {
        this.defaultColor = false;
      }
    }
    if (!this.isLastKnownEnabled) {
      if (this.inputError) {
        this.defaultColor = false;
      }
    }
    if (this.hasTouchDimTwEnabled() && this.isTwEnabled !== this.field.properties.TouchDimTwEnabled.default) {
      this.defaultColor = false;
    }
    if (this.hasPowerOnCCT() && this.isTwEnabled && !this.isLastKnownEnabled) {
      if (this.cctTextboxValue !== this.field.properties.PowerOnCCT.default) {
        this.defaultColor = false;
      }
      if (this.cctInputError) {
        this.defaultColor = false;
      }
    }
  }
  toggleLimitEnabled(event) {
    this.ngModelval["IgnoreToggleLimits"] = event;
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.sendTouchDimData();
  }
  twEnabledChanged(event) {
    this.isTwEnabled = event;
    this.ngModelval["TouchDimTwEnabled"] = event;
    if (this.hasPowerOnCCT()) {
      this.cctSliderDisabled = this.isLastKnownEnabled || !event;
    }
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.sendTouchDimData();
  }
  cctSliderEvent(val) {
    this.defaultColor = false;
    this.cctInputError = false;
    if (isNaN(val) || val < this.cctFloorValue || val > this.cctCeilValue) {
      this.cctInputError = true;
      this.cctTextboxValue = val;
      this.cctSliderValue = Number(val);
    } else {
      this.cctTextboxValue = val;
      this.cctSliderValue = val;
    }
    this.ngModelval["PowerOnCCT"] = this.cctTextboxValue;
    this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.sendTouchDimData();
  }
  cctValueChanged(value) {
    this.defaultColor = false;
    this.cctInputError = false;
    if (isNaN(value) || value.toString().length <= 0 || value < this.cctFloorValue || value > this.cctCeilValue) {
      this.cctInputError = true;
      this.cctTextboxValue = value;
      if (value.toString().length <= 0) {
        this.cctSliderValue = Number(0);
      }
    } else {
      this.cctTextboxValue = value;
      this.cctSliderValue = value;
    }
    this.ngModelval["PowerOnCCT"] = this.cctTextboxValue;
    this.inputErrors.sendTouchDimInputError(this.inputError || this.cctInputError);
    this.checkDefault();
    this.featureDefaults.setTouchDimDefaultColor(this.defaultColor);
    this.sendTouchDimData();
  }
  cctSliderValueChange(value) {
    this.cctSliderEvent(value);
  }
  sendTouchDimData() {
    this.inputErrors.setTouchDimEditedData(this.ngModelval);
    if (this.isEdited) {
      this.setConfigurationData(this.ngModelval, "TouchDim");
    }
  }
  ngOnDestroy() {
    this.inputErrors.setTouchDimEditedData("");
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private getPowerOnLevelConst(): number {
    if (this.field.oneOf) {
      return this.field.oneOf[0].properties.PowerOnLevel.const;
    }
    return this.field.properties.PowerOnLevel.oneOf[0].const;
  }

  private getPowerOnLevelMin(): number {
    if (this.field.oneOf) {
      return this.field.oneOf[1].properties.PowerOnLevel.minimum;
    }
    return this.field.properties.PowerOnLevel.oneOf[1].minimum;
  }

  private getPowerOnLevelMax(): number {
    if (this.field.oneOf) {
      return this.field.oneOf[1].properties.PowerOnLevel.maximum;
    }
    return this.field.properties.PowerOnLevel.oneOf[1].maximum;
  }

  hasPowerOnCCT(): boolean {
    return this.field?.requiredProperties?.includes('PowerOnCCT') ?? false;
  }

  hasTouchDimTwEnabled(): boolean {
    return this.field?.requiredProperties?.includes('TouchDimTwEnabled') ?? false;
  }

  private getPowerOnCCTConst(): number {
    return this.field.properties.PowerOnCCT.oneOf[0].const;
  }

  private getPowerOnCCTMin(): number {
    return this.field.properties.PowerOnCCT.oneOf[1].minimum;
  }

  private getPowerOnCCTMax(): number {
    return this.field.properties.PowerOnCCT.oneOf[1].maximum;
  }
}
